import {Component} from '@angular/core';
import {AngularFireDatabase} from 'angularfire2/database';
import {AngularFireAuth} from 'angularfire2/auth';
import {Observable} from 'rxjs/Observable';
import * as firebase from 'firebase/app';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    title = 'Time Tracker';
    user: Observable<firebase.User>;

    constructor(public afAuth: AngularFireAuth, public af: AngularFireDatabase, translate: TranslateService, router: Router) {
        this.user = this.afAuth.authState;

        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang('en');

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        // translate.use('es');
        // translate.use('en');
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts